import {ValueObject} from '@s-ui/domain'

export class UpdateBuyerTradeDataRequestTransactionsValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {String} data.tradeId
   */
  constructor({address, city, lastName, name, personalId, phone, professionalActivityCode, tradeId, zipCode}) {
    super()

    this._address = address
    this._city = city
    this._lastName = lastName
    this._name = name
    this._personalId = personalId
    this._phone = phone
    this._professionalActivityCode = professionalActivityCode
    this._tradeId = tradeId
    this._zipCode = zipCode
  }

  static create = ({
    address = '',
    city = '',
    lastName = '',
    name = '',
    personalId = '',
    phone,
    professionalActivityCode,
    tradeId,
    zipCode = ''
  }) => {
    return new UpdateBuyerTradeDataRequestTransactionsValueObject({
      address,
      city,
      lastName,
      name,
      personalId,
      phone,
      professionalActivityCode,
      tradeId,
      zipCode
    })
  }

  getTradeId() {
    return this._tradeId
  }

  toJSON() {
    return {
      address: this._address.trim(),
      city: this._city.trim(),
      lastName: this._lastName.trim(),
      name: this._name.trim(),
      personalId: this._personalId.trim(),
      phone: this._phone,
      professionalActivityCode: this._professionalActivityCode,
      tradeId: this._tradeId,
      zipCode: this._zipCode.trim()
    }
  }
}
